export const formatNumberPtbr = (number) => Number(number).toLocaleString('pt-BR');
